export enum QuestionCategories {
  authentic = 1,
  transforming = 2,
  reliable = 3,
  achieving = 4,
  encouraging = 5,
  relating = 6,
  compassionate = 7,
  developing = 8,
  controlling = 9,
  competitive = 10,
  striving = 11,
  sarcastic = 12,
  approvalSeeking = 13,
  avoiding = 14,
  easilyOffended = 15,
  dependent = 16
}
